module.exports = __webpack_public_path__ + "img/img_sub_prod_autostation.00ab74fd.svg";